import * as React from 'react'
import { QuizType } from '../../../../commons/EditorStatus'
import * as styles from './IndexTitle.css'

interface IndexTitleProps {
  type: number | null
  index: number | null
  isSelected: boolean
}

const IndexTitle: React.FunctionComponent<IndexTitleProps> = ({ type, index, isSelected = false }) => {
  let title = ''
  if (type === QuizType.FIRSTPAGE.value) {
    title = QuizType.FIRSTPAGE.label
  } else if (type === QuizType.RANKING.value) {
    title = QuizType.RANKING.label
  } else {
    title = `第${index}問`
  }

  const containerClass = isSelected ? styles.containerSelected : styles.containerNonSelected
  return (
    <div className={containerClass}>
      <div className={styles.lText}>
        <p className={styles.text}>{title}</p>
      </div>
    </div>
  )
}

export default IndexTitle
